// Product modal mutations
export const SET_SHOW_PRODUCT_STATUS_MODAL = "SET_SHOW_PRODUCT_STATUS_MODAL";

// Product row ID mutations
export const SET_SINGLE_PRODUCT_DELETE_ROW_ID =
  "SET_SINGLE_PRODUCT_DELETE_ROW_ID";
export const SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID =
  "SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID";

// Product list mutations
export const SET_PRODUCT_LIST_ACTIVE_TAB = "SET_PRODUCT_LIST_ACTIVE_TAB";

// Product loading mutations
export const SET_PRODUCTS_LOADING = "SET_PRODUCTS_LOADING";
export const SET_PRODUCTS_DATA = "SET_PRODUCTS_DATA";
export const SET_PRODUCTS_ERROR = "SET_PRODUCTS_ERROR";

// Product update mutations
export const SET_IS_PRICE_AREA_UPDATE = "SET_IS_PRICE_AREA_UPDATE";
export const SET_ACTIVE_INPUT_ID = "SET_ACTIVE_INPUT_ID";
export const SET_IS_PRICE_AREA_STATUS = "SET_IS_PRICE_AREA_STATUS";
export const SET_IS_PRICE_AREA_ERROR_MESSAGE =
  "SET_IS_PRICE_AREA_ERROR_MESSAGE";
export const SET_SUB_TABS_BY_KEY = 'SET_SUB_TABS_BY_KEY';